<template>
    <div class="container">
        <div>
            <form v-on:submit.prevent="onSubmit">
                <div class="form-group text-left">
                    <h2>ข้อมูลทั่วไป</h2>
                    <hr>
                    <p>สถานะผู้เข้าร่วมงาน <span class="req-field">*</span></p>
                    <div class="row">
                        <div class="col-lg-3 col-sm-12">
                            <select v-model="status" class="custom-select">
                                <option value="student">นักเรียน</option>
                                <option value="collegian">นิสิต / นักศึกษา</option>
                                <option value="teacher">อาจารย์</option>
                                <option value="visitor">บุคคลทั่วไป</option>
                            </select>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-4 col-sm-12">
                            <label class="control-label">เพศ <span class="req-field">*</span></label>
                            <select v-model="sex" class="custom-select">
                                <option value="male">ชาย</option>
                                <option value="female">หญิง</option>
                                <option value="other">อื่นๆ</option>
                                <option value="nonSpecify">ไม่ระบุ</option>
                            </select>
                        </div>
                        <div class="col-lg-4 col-sm-12">
                            <label class="control-label">ชื่อ <span class="req-field">*</span></label>
                            <input type="name" class="form-control" placeholder="ชื่อ" v-model="name" required>
                        </div>
                        <div class="col-lg-4 col-sm-12">
                            <label class="control-label">นามสกุล <span class="req-field">*</span></label>
                            <input type="name" class="form-control" placeholder="นามสกุล" v-model="surname" required>
                        </div>
                    </div>

                    <div v-if="status != 2">
                        <div class="row">
                            <div class="col-lg-4 col-sm-12">
                                <label>สถานศึกษาในจังหวัด <span class="req-field">*</span></label>
                                <input type="text" class="form-control" placeholder="จังหวัด" v-model="province" required>
                            </div>
                            <div class="col-lg-4 col-sm-12">
                                <label>ชื่อสถานศีกษา <span class="req-field">*</span></label>
                                <input type="text" class="form-control" placeholder="โรงเรียน/วิทยาลัย" v-model="school" required>
                            </div>
                            <div class="col-lg-4 col-sm-12">
                                <label>ระดับชั้น <span class="req-field">*</span></label>
                                <select required v-model="grade" class="custom-select">
                                    <option value="primarySchool">ประถมศึกษา</option>
                                    <option value="juniorHighSchool">มัธยมศึกษาตอนต้น</option>
                                    <option value="seniorHighSchool">มัธยมศึกษาตอนปลาย</option>
                                    <option value="vocational">ปวช. / ปวส.</option>
                                    <option value="bachelorDegrees">ปริญญาตรี</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6 col-sm-12">
                            <label>เบอร์โทรติดต่อ <span class="req-field">*</span></label>
                            <input type="tel" class="form-control" placeholder="เบอร์โทรติดต่อ" v-model="tel" required>
                        </div>
                        <div class="col-lg-6 col-sm-12">
                            <label>E-mail <span class="req-field">*</span></label>
                            <input type="email" class="form-control" placeholder="E-mail" v-model="email" required>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-3 col-sm-12">
                            <label>Line ID</label>
                            <input type="text" class="form-control" placeholder="ไอดีไลน์" v-model="idline">
                        </div>
                    </div>
                </div>

                <div class="form-group text-left">
                    <h2>ลำดับคณะที่สนใจ 3 อันดับแรก <span class="req-field">*</span></h2><hr>
                    <div class="row">
                        <div class="col-lg-4 col-sm-12">
                            <select required v-model="faculty1" class="custom-select">
                                <option disabled selected value="-1">-- เลือกคณะที่คุณสนใจอันดับที่ 1 --</option>
                                <option value="EN" v-if="faculty2 != 'EN' && faculty3 != 'EN'">คณะวิศวกรรมศาสตร์</option>
                                <option value="ARCH" v-if="faculty2 != 'ARCH' && faculty3 != 'ARCH'">คณะสถาปัตยกรรมศาสตร์</option>
                                <option value="IETECH" v-if="faculty2 != 'IETECH' && faculty3 != 'IETECH'">คณะครุศาสตร์อุตสาหกรรม</option>
                                <option value="AGRO" v-if="faculty2 != 'AGRO' && faculty3 != 'AGRO'">คณะอุตสาหกรรมการเกษตร</option>
                                <option value="AGRI" v-if="faculty2 != 'AGRI' && faculty3 != 'AGRI'">คณะเทคโนโลยีการเกษตร</option>
                                <option value="SCI" v-if="faculty2 != 'SCI' && faculty3 != 'SCI'">คณะวิทยาศาสตร์</option>
                                <option value="IT" v-if="faculty2 != 'IT' && faculty3 != 'IT'">คณะเทคโนโลยีสารสนเทศ</option>
                                <option value="FAM" v-if="faculty2 != 'FAM' && faculty3 != 'FAM'">คณะการบริหารและการจัดการ</option>
                                <option value="LA" v-if="faculty2 != 'LA' && faculty3 != 'LA'">คณะศิลปศาสตร์</option>
                                <option value="NANO" v-if="faculty2 != 'NANO' && faculty3 != 'NANO'">วิทยาลัยนาโนเทคโนโลยี</option>
                                <option value="AMI" v-if="faculty2 != 'AMI' && faculty3 != 'AMI'">วิทยาลัยนวัตกรรมการผลิตขั้นสูง</option>
                                <option value="IC" v-if="faculty2 != 'IC' && faculty3 != 'IC'">วิทยาลัยนานาชาติ</option>
                                <option value="MUSIC" v-if="faculty2 != 'MUSIC' && faculty3 != 'MUSIC'">วิทยาลัยวิศวกรรมสังคีต</option>
                                <option value="AEC" v-if="faculty2 != 'AEC' && faculty3 != 'AEC'">วิทยาลัยอุตสาหกรรมการบินนานาชาติ</option>
                                <option value="CHUMPHON" v-if="faculty2 != 'CHUMPHON' && faculty3 != 'CHUMPHON'">วิทยาเขตชุมพรอุดมศักดิ์ จังหวัดชุมพร</option>
                                <option value="MED" v-if="faculty2 != 'MED' && faculty3 != 'MED'">คณะแพทยศาสตร์</option>
                                <option value="EDU" v-if="faculty2 != 'EDU' && faculty3 != 'EDU'">วิทยาลัยวิจัยนวัตกรรมทางการศึกษา</option>
                            </select>
                        </div>
                        <div class="col-lg-4 col-sm-12">
                            <select required v-model="faculty2" class="custom-select">
                                <option disabled selected value="-1">-- เลือกคณะที่คุณสนใจอันดับที่ 2 --</option>
                                <option value="EN" v-if="faculty1 != 'EN' && faculty3 != 'EN'">คณะวิศวกรรมศาสตร์</option>
                                <option value="ARCH" v-if="faculty1 != 'ARCH' && faculty3 != 'ARCH'">คณะสถาปัตยกรรมศาสตร์</option>
                                <option value="IETECH" v-if="faculty1 != 'IETECH' && faculty3 != 'IETECH'">คณะครุศาสตร์อุตสาหกรรม</option>
                                <option value="AGRO" v-if="faculty1 != 'AGRO' && faculty3 != 'AGRO'">คณะอุตสาหกรรมการเกษตร</option>
                                <option value="AGRI" v-if="faculty1 != 'AGRI' && faculty3 != 'AGRI'">คณะเทคโนโลยีการเกษตร</option>
                                <option value="SCI" v-if="faculty1 != 'SCI' && faculty3 != 'SCI'">คณะวิทยาศาสตร์</option>
                                <option value="IT" v-if="faculty1 != 'IT' && faculty3 != 'IT'">คณะเทคโนโลยีสารสนเทศ</option>
                                <option value="FAM" v-if="faculty1 != 'FAM' && faculty3 != 'FAM'">คณะการบริหารและการจัดการ</option>
                                <option value="LA" v-if="faculty1 != 'LA' && faculty3 != 'LA'">คณะศิลปศาสตร์</option>
                                <option value="NANO" v-if="faculty1 != 'NANO' && faculty3 != 'NANO'">วิทยาลัยนาโนเทคโนโลยี</option>
                                <option value="AMI" v-if="faculty1 != 'AMI' && faculty3 != 'AMI'">วิทยาลัยนวัตกรรมการผลิตขั้นสูง</option>
                                <option value="IC" v-if="faculty1 != 'IC' && faculty3 != 'IC'">วิทยาลัยนานาชาติ</option>
                                <option value="MUSIC" v-if="faculty1 != 'MUSIC' && faculty3 != 'MUSIC'">วิทยาลัยวิศวกรรมสังคีต</option>
                                <option value="AEC" v-if="faculty1 != 'AEC' && faculty3 != 'AEC'">วิทยาลัยอุตสาหกรรมการบินนานาชาติ</option>
                                <option value="CHUMPHON" v-if="faculty1 != 'CHUMPHON' && faculty3 != 'CHUMPHON'">วิทยาเขตชุมพรอุดมศักดิ์ จังหวัดชุมพร</option>
                                <option value="MED" v-if="faculty1 != 'MED' && faculty3 != 'MED'">คณะแพทยศาสตร์</option>
                                <option value="EDU" v-if="faculty1 != 'EDU' && faculty3 != 'EDU'">วิทยาลัยวิจัยนวัตกรรมทางการศึกษา</option>
                            </select>
                        </div>
                        <div class="col-lg-4 col-sm-12">
                            <select required v-model="faculty3" class="custom-select">
                                <option disabled selected value="-1">-- เลือกคณะที่คุณสนใจอันดับที่ 3 --</option>
                                <option value="EN" v-if="faculty2 != 'EN' && faculty1 != 'EN'">คณะวิศวกรรมศาสตร์</option>
                                <option value="ARCH" v-if="faculty2 != 'ARCH' && faculty1 != 'ARCH'">คณะสถาปัตยกรรมศาสตร์</option>
                                <option value="IETECH" v-if="faculty2 != 'IETECH' && faculty1 != 'IETECH'">คณะครุศาสตร์อุตสาหกรรม</option>
                                <option value="AGRO" v-if="faculty2 != 'AGRO' && faculty1 != 'AGRO'">คณะอุตสาหกรรมการเกษตร</option>
                                <option value="AGRI" v-if="faculty2 != 'AGRI' && faculty1 != 'AGRI'">คณะเทคโนโลยีการเกษตร</option>
                                <option value="SCI" v-if="faculty2 != 'SCI' && faculty1 != 'SCI'">คณะวิทยาศาสตร์</option>
                                <option value="IT" v-if="faculty2 != 'IT' && faculty1 != 'IT'">คณะเทคโนโลยีสารสนเทศ</option>
                                <option value="FAM" v-if="faculty2 != 'FAM' && faculty1 != 'FAM'">คณะการบริหารและการจัดการ</option>
                                <option value="LA" v-if="faculty2 != 'LA' && faculty1 != 'LA'">คณะศิลปศาสตร์</option>
                                <option value="NANO" v-if="faculty2 != 'NANO' && faculty1 != 'NANO'">วิทยาลัยนาโนเทคโนโลยี</option>
                                <option value="AMI" v-if="faculty2 != 'AMI' && faculty1 != 'AMI'">วิทยาลัยนวัตกรรมการผลิตขั้นสูง</option>
                                <option value="IC" v-if="faculty2 != 'IC' && faculty1 != 'IC'">วิทยาลัยนานาชาติ</option>
                                <option value="MUSIC" v-if="faculty2 != 'MUSIC' && faculty1 != 'MUSIC'">วิทยาลัยวิศวกรรมสังคีต</option>
                                <option value="AEC" v-if="faculty2 != 'AEC' && faculty1 != 'AEC'">วิทยาลัยอุตสาหกรรมการบินนานาชาติ</option>
                                <option value="CHUMPHON" v-if="faculty2 != 'CHUMPHON' && faculty1 != 'CHUMPHON'">วิทยาเขตชุมพรอุดมศักดิ์ จังหวัดชุมพร</option>
                                <option value="MED" v-if="faculty2 != 'MED' && faculty1 != 'MED'">คณะแพทยศาสตร์</option>
                                <option value="EDU" v-if="faculty2 != 'EDU' && faculty1 != 'EDU'">วิทยาลัยวิจัยนวัตกรรมทางการศึกษา</option>
                            </select>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6 col-sm-12">
                            <label>รับข่าวสารจากที่ไหน <span class="req-field">*</span></label>
                            <select required v-model="news" class="custom-select">
                                <option value="guidance">ครูแนะแนวของโรงเรียน</option>
                                <option value="website">เว็บไซด์งาน</option>
                                <option value="onlineMedia">สื่อออนไลน์</option>
                                <option value="friend">เพื่อน</option>
                                <option value="other">อื่นๆ (โปรดระบุ)</option>
                            </select>
                            <input type="text" class="form-control" placeholder="ช่องทางที่คุณได้รับข่าวสาร" v-model="morenews" v-if="news == 4" required>
                        </div>
                    </div>
                </div>
                <button type="submit" class="btn btn-primary" v-bind:class="{ disabled: isActive }">ลงทะเบียน</button>
            </form>

            <div v-if="showModal">
                <transition name="modal">
                <div class="modal-mask">
                    <div class="modal-wrapper">

                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title req-field">เเจ้งเตือน</h5>
                                <a  class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true" @click="showModal = false">&times;</span>
                                </a>
                            </div>
                            <div class="modal-body">
                                <p>{{ modalmsg }}</p>
                            </div>
                        </div>
                    </div>

                    </div>
                </div>
                </transition>
            </div>

        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import axios from 'axios'
import { mapMutations } from 'vuex'

Vue.use(BootstrapVue)
export default {
  name: 'RegisterState',
  data () {
    return {
      modalmsg: "",
      isActive: false,
      sex: "male",
      status: "student",
      province: "",
      grade: "primarySchool",
      headerName: null,
      name: "",
      surname: "",
      school: "",
      tel: "",
      email: "",
      idline: "",
      news: "guidance",
      morenews: "",
      faculty1: "-1",
      faculty2: "-1",
      faculty3: "-1",
      parent_name: "",
      parent_surname: "",
      parent_address: "",
      parent_tel: "",
      showModal: false,
    }
  },
  methods: {
    ...mapMutations([
      'setUsername', // map `this.increment()` to `this.$store.commit('increment')`
      'setPassword' // map `this.incrementBy(amount)` to `this.$store.commit('incrementBy', amount)`
    ]),
    onSubmit() {
     if (this.faculty1 == "-1") {
        this.modalmsg = "โปรดเลือกลำดับคณะที่คุณสนใจทั้ง 3 ลำดับ"
        this.showModal = true;
        return "";
      }
      else if (this.faculty2 == "-1") {
        this.modalmsg = "โปรดเลือกลำดับคณะที่คุณสนใจทั้ง 3 ลำดับ"
        this.showModal = true;
        return "";
      }
      else if (this.faculty3 == "-1") {
        this.modalmsg = "โปรดเลือกลำดับคณะที่คุณสนใจทั้ง 3 ลำดับ"
        this.showModal = true;
        return "";
      }
      this.modalmsg = "กรุณารอซักครู่ระบบกำลังทำการลงทะเบียนให้คุณ"
      this.showModal = true;
      axios({
          method: "POST",
          url: "https://us-central1-oph2019-kmitl-c2dac.cloudfunctions.net/user/register",
          headers: {
            "Content-Type": "application/json"
          },
          data: {
            "firstname": this.name,
            "surname": this.surname,
            "email": this.email,
            "acknowledge": this.news,
            "address": this.parent_address,
            "headerName": null,
            "level": null,
            "primary": this.grade,
            "first": this.faculty1,
            "second": this.faculty2,
            "third": this.faculty3,
            "lineId": this.idline,
            "province": this.province,
            "schools": this.school,
            "tel": this.tel,
            "role": this.status,
            "sex": this.sex
          }
      })
      .then((res) => {
        this.isActive = !this.isActive;
        this.setUsername(res.data.username)
        this.setPassword(res.data.password)
        // console.log(this.$store.state.profile)
        this.$router.push('/created')
      })
      .catch((err) => {
        // console.log(err)
      })
    }
  }
}

</script>

<style lang="css" scoped>
.modal-title {
    color: #ee4b23;
}

.form-control {
    margin-bottom: 1em;
}

select.custom-select {
    display: block;
    width: 100%;
    height: calc(1.5em + .75rem + 2px);
    padding: .375rem .75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: .25rem;
    margin-bottom: 1em;
    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;
}

.form-group {
    margin-top: 1em;
    margin-bottom: 1em;
    border-left: #ee4b23 solid 3px;
    padding-left: 1em;
}

form {
    margin-bottom: 1em;
}

h2 {
    color: #ee4b23;
}

.btn-primary {
  color: #fff;
  background-color: #ee4b23;
  border-color: #ee4b23;
  cursor: pointer;
}

.btn-primary:hover {
  color: #fff;
  background-color: #ee4b23;
  border-color: #ee4b23;
  cursor: pointer;
}

.btn-primary:not(:disabled):not(.disabled).active, .btn-primary:not(:disabled):not(.disabled):active, .show>.btn-primary.dropdown-toggle {
  color: #fff;
  background-color: #ee4b23;
  border-color: #ee4b23;
  cursor: pointer;
}


.req-field {
    color: #ee4b23;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .9s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
</style>
